import { Box, Tabs, Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import ProfileHeader from "../../../common/components/profile-header/profile-header-and-breadcrumbs";
import { routes } from "../../../constants/routes";
import BasicInformation from "./tabs/basic-information";
import LocationDetails from "./tabs/location-details";
import ServicesOfferings from "./tabs/service-offerings";
import Documentation from "./tabs/documentation";
import BankInformation from "./tabs/bank-information";
import { MOCK_DATA } from "./data";
import { getProviderProfileManagementDetails } from "../../../api/provider-section/provider-service-management";
import "./profile-management-tabs.scss";
import { useSetLoading } from "../../../common/hooks/appearance";

const ProfileManagementTabs: React.FC = () => {
  const breadcrumbLink = [
    {
      label: "Profile Management",
      link: routes.PROVIDER_PROFILE_MGMT,
      handleClick: () => { },
    },
  ];

  const providerDetailsStr = localStorage.getItem("providerDetails");
  let partnerId: string | undefined;

  if (providerDetailsStr) {
    try {
      const providerDetails = JSON.parse(providerDetailsStr);
      partnerId = providerDetails?.provider.partnerId;
    } catch (error) {
      console.error(
        "Failed to parse providerDetails from localStorage:",
        error,
      );
    }
  }

  const [activeTab, setActiveTab] = useState<number>(0);
  const [profileData, setProfileData] = useState<any>(MOCK_DATA.data);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useSetLoading(isLoading);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const fetchProfileData = async () => {
    setIsLoading(true);
    try {
      const response = await getProviderProfileManagementDetails();
      setProfileData(response.data.data);
    } catch (error) {
      console.error("ERROR fetching profile data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProfileData();
  }, []);

  return (
    <Box className="profile-management">
      <ProfileHeader breadcrumbLink={breadcrumbLink} mode="provider" />

      <Box className="profile-management__tabs">
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          className="profile-management__tabs-header"
        >
          <Tab label="Basic Information" />
          <Tab label="Location & Media Details" />
          <Tab label="Service Offerings" />
          <Tab label="Documentation" />
          <Tab label="Bank Information" />
        </Tabs>
      </Box>

      <Box className="profile-management__content">
        {activeTab === 0 && (
          <BasicInformation data={profileData.basic_information} refresh={fetchProfileData} />
        )}
        {activeTab === 1 && (
          <LocationDetails data={profileData.location_media_details} refresh={fetchProfileData} />
        )}
        {activeTab === 2 && (
          <ServicesOfferings data={profileData.service_offerings} refresh={fetchProfileData} />
        )}
        {activeTab === 3 && (
          <Documentation data={profileData.documents} refresh={fetchProfileData} />
        )}
        {activeTab === 4 && (
          <BankInformation data={profileData.banking_information} />
        )}
      </Box>
    </Box>
  );
};

export default ProfileManagementTabs;
